import { render, staticRenderFns } from "./PatientTransferAction.vue?vue&type=template&id=34cf757a&"
import script from "./PatientTransferAction.vue?vue&type=script&lang=js&"
export * from "./PatientTransferAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports